(function() {
  window.checkAspectRatioSupport = function() {
    return typeof document.documentElement.style.aspectRatio !== 'undefined';
  };

  window.checkMixBlendModeSupport = function() {
    return typeof document.documentElement.style.mixBlendMode !== 'undefined';
  };

  window.checkMaskImageSupport = function() {
    const prefixes = ['', '-webkit-', '-moz-'];
    const testElement = document.createElement('div');
    for (let i = 0; i < prefixes.length; i++) {
      if (typeof testElement.style[prefixes[i] + 'maskImage'] !== 'undefined') {
        return true;
      }
    }
    return false;
  };

  window.checkWebPSupport = function() {
    try {
      return document.createElement('canvas').toDataURL('image/webp', 0.5).indexOf('data:image/webp') === 0;
    } catch (e) {
      return false;
    }
  };

  $(document).ready(function() {
    // Example usage including WEBP:
    console.log('aspect-ratio support:', window.checkAspectRatioSupport());
    console.log('mix-blend-mode support:', window.checkMixBlendModeSupport());
    console.log('mask-image support:', window.checkMaskImageSupport());
    console.log('WEBP support:', window.checkWebPSupport());



  });

})();
